class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      this.closest('.cart-item').classList.add('removing');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#cart-footer-amount',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#cart-footer-delivery',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#klarna-laybuy-section',
      }
      
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
        //window.location.reload();
        const cart_count = document.querySelectorAll('.cart-count');
        cart_count.forEach(function(el){
          el.innerHTML = parsedState.item_count;
        })
        window.saso.cart = parsedState;
        window.saso.page_type = 'cart';
        delete window.saso.discounts;
        delete window.saso.page_actions_data;
        delete window.saso.saso_shown_upsells;
        var settings = {
          "url": "https://specialoffers.suppleapps.com/api/v2/page-actions?data-product-handles",
          "method": "POST",
          "timeout": 0,
          "headers": {
            "Content-Type": "application/json"
          },
          "data": JSON.stringify(window.saso),
        };

        $.ajax(settings).done(function (response) {
          if(response.discounts){
            const total_discount = response.discounts.total_discount_amount_html;
            const totalDisc = document.querySelectorAll('.saso-total-discount');
            const saso_total = document.querySelectorAll('.saso-cart-total');
            const saso_items = response.discounts.cart.items;
            const klarna = document.querySelector('#klarna-installment');
            const laybuy = document.querySelector('#laybuy-installment');
            const bodyEl = document.querySelector('body');
            if(response.discounts && response.discounts.total_discount_amount > 0){
              totalDisc.forEach((el) => {
                el.innerHTML = total_discount;
                el.parentNode.classList.remove('hidden');
              });
              saso_total.forEach((el) => {
                el.innerHTML = response.discounts.discounted_price_html;
              });
              saso_items.forEach((el) => {
                const vId = el.variant_id;
                let upsell_notes = "";
                const itemEl = document.querySelector(`.cart-item[data-variant-id="${vId}"]`);
                if(!itemEl){
                  return;
                }
                const upsellNotesEl = itemEl.querySelector('.saso-cart-item-upsell-notes');
                const itemLinePriceEl = itemEl.querySelector('.saso-cart-item-line-price');
                const itemPriceEl = itemEl.querySelector('.saso-cart-item-price');
                if(el.upsell_notes.length > 0){
                  for(i in el.upsell_notes){
                    upsell_notes += (i > 0) ? '<br/>' : '';
                    upsell_notes += el.upsell_notes[i];
                  }
                }
                upsellNotesEl.innerHTML = upsell_notes;
                const itemLinePrice = `<span class="original_price">${el.original_line_price}</span>
                                   <span class="discounted_price">${el.discounted_line_price_format}</span>`;
                itemLinePriceEl.innerHTML = itemLinePrice;
                const itemPrice = `<span class="original_price">${el.original_line_price_format}</span>
                                   <span class="discounted_price">${el.discounted_price_format}</span>`;
                itemPriceEl.innerHTML = itemPrice;
              });
              if(klarna){
                klarna.innerHTML = Shopify.formatMoney(response.discounts.discounted_price * 100 / parseInt(klarna.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
              }
              if(laybuy){
                laybuy.innerHTML = Shopify.formatMoney(response.discounts.discounted_price * 100 / parseInt(laybuy.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
              }
            }else{
              const deliveryCost = document.querySelector('[data-delivery-cost]').innerText;
              const deliveryCostVal = Number(deliveryCost.replace(/[^0-9.-]+/g,""));
              const totalPrice = parseFloat(response.discounts.cart.original_total_price) + parseFloat(deliveryCostVal);
              totalDisc.forEach((el) => {
                el.parentNode.classList.add('hidden');
              });
              saso_total.forEach((el) => {
                el.innerHTML = Shopify.formatMoney(totalPrice * 100, bodyEl.getAttribute('data-money'));
              });
              if(klarna){
                klarna.innerHTML = Shopify.formatMoney(totalPrice * 100 / parseInt(klarna.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
              }
              if(laybuy){
                laybuy.innerHTML = Shopify.formatMoney(totalPrice * 100 / parseInt(laybuy.getAttribute('data-installment')), bodyEl.getAttribute('data-money'));
              }
            }
          }
        });
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = "You have added all available units to your basket!";
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { line, itemCount } }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};


